import * as React from "react";
import SubscriptionIcons from "../../../assets/icons/svgIcons/subscriptionIcons";
import {Idevice} from "../../types/device";
import DeviceContext from "../../service/indentifyDevice";

const handleDevice: Idevice = DeviceContext();
export default function IPServiceList(): React.ReactElement {
    return (
        <ul className="mg-b50">
            <li>
                <i>
                    <SubscriptionIcons
                        icon="support"
                        width="30.203"
                        height="30"
                        style={handleDevice.isMobile ? { width: "29.4px", height: "29.3px" } : {}}
                    />
                </i>
                <p>RM support & tailor made plans</p>
            </li>
            <li>
                <i>
                    <SubscriptionIcons
                        icon="commission"
                        width="30"
                        height="29.911"
                        style={handleDevice.isMobile ? { width: "30px", height: "31.5px" } : {}}
                    />
                </i>
                <p>Zero commission funds with Direct MF</p>
            </li>

            <li>
                <i>
                    <SubscriptionIcons
                        icon="charges"
                        width="30"
                        height="31.489"
                        style={handleDevice.isMobile ? { width: "29.2px", height: "29.2px" } : {}}
                    />
                </i>
                <p>Free call & trade</p>
            </li>

            <li>
                <i>
                    <SubscriptionIcons
                        icon="research"
                        width="30.5"
                        height="30.502"
                        style={handleDevice.isMobile ? { width: "30px", height: "30px" } : {}}
                    />
                </i>
                <p>Extensive & in-depth Research</p>
            </li>

            <li>
                <i>
                    <SubscriptionIcons
                        icon="webinar"
                        width="32.401"
                        height="30"
                        style={handleDevice.isMobile ? { width: "32.4px", height: "30px" } : {}}
                    />
                </i>

                <p>Exclusive webinars with {handleDevice.isMobile ? "" : "industry"} experts</p>
            </li>
            <li>
                <i>
                    <SubscriptionIcons
                        icon="platforms"
                        width="28"
                        height="25.305"
                        style={handleDevice.isMobile ? { width: "28px", height: "21.2px" } : {}}
                    />
                </i>
                <p>Platforms with advanced tools</p>
            </li>
        </ul>
    );
}
